<template>
    <header >
        <img :src="type == 'back' ? '/LSHeaderBack.png' : '/LSHeaderPlain.png'" @click="clicked" />
        <img v-if="avatar" src="/AvatarWhite.png" style="position: absolute;width: 40px;height: 40px;padding:20px;right:0px;top:0px" @click="$emit('avatar')" />
    </header>
</template>

<script>

export default {
    props: ['type','avatar'],
    computed: {
        host () { return this.$store.state.host }
    },
    methods: {
        clicked () {
            this.type == 'back' ? this.$emit('back') : this.$emit('ham');
        }
    }
}

</script>

<style lang="scss">
header {
  width: 100%;
  position: relative;
  border-bottom: 2px solid whitesmoke;
  float: left;
  img {
      width: 100%;
      float: left;
  }
}
</style>